import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type SaveBookmarkRequest } from '../services/saveBookmarkService'

export interface SaveBookmarkObjectState {
  saveBookmarkObject: SaveBookmarkRequest | null
}

// Initial state of the slice
const initialState: SaveBookmarkObjectState = {
  saveBookmarkObject: {
    bookmarkType: 'BOOKMARK',
    dashboardId: null,
    dashboardType: 'ASSET'
  }
}

// Slice to return from action
export const SaveBookmarkObjectGlobalState = createSlice({
  name: 'SaveBookmarkObjectGlobalState',
  initialState,
  reducers: {
    SaveBookmarkObjectUpdateAction: (
      state: SaveBookmarkObjectState,
      action: PayloadAction<any>
    ) => {
    // istanbul ignore next
      return {
        saveBookmarkObject: action.payload ?? initialState.saveBookmarkObject
      }
    }
  }
})

// Actions to export
export const { SaveBookmarkObjectUpdateAction } =
  SaveBookmarkObjectGlobalState.actions

export default SaveBookmarkObjectGlobalState.reducer
